// extracted by mini-css-extract-plugin
export default {"list":"QuestionsList_list__NN3y3"};